import { render, staticRenderFns } from "./SportEventsIndex.vue?vue&type=template&id=8168cf78&"
import script from "./SportEventsIndex.vue?vue&type=script&lang=js&"
export * from "./SportEventsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports